export const mimetype = {
    CSV: "text/csv",
    JSON: "application/json",
    XML: "text/xml",
    XMLA: "application/xml",
    XSLX: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
} as const;
